// START IMPORTS
import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { useReportMonitors } from '@ltvco/refresh-lib/hooks';
import {
  Box,
  CustomIcons,
  Stack,
  Text,
  useTheme,
} from '@ltvco/refresh-lib/theme';
import { useMemo } from 'react';

import { filterAndSortReports } from 'routes/Dashboard/IdentityHub/utils';

import { ClaimedReportMonitorsContainer } from './ClaimedReportMonitorsContainer';
// END IMPORTS

export const ClaimedReportMonitorTiles = () => {
  // START HOOKS_AND_QUERIES
  const { currentMonitors } = useReportMonitors();
  const { isHidden } = useSubscriptionAccessConfigContext();
  const theme = useTheme();

  const filteredAndSortedReports = useMemo(
    () => filterAndSortReports(currentMonitors || []),
    [currentMonitors]
  );
  // END HOOKS_AND_QUERIES

  // START DERIVED_DATA_AND_UTILS
  const claimedPersonReports =
    filteredAndSortedReports['detailed_person_report'];
  const claimedEmailReports = filteredAndSortedReports['social_network_report'];
  const claimedPhoneReports = filteredAndSortedReports['reverse_phone_report'];
  const claimedSocialMediaReports = filteredAndSortedReports['username_report'];
  const claimedPropertyReports = filteredAndSortedReports['property_report'];
  const claimedVehicleReports = filteredAndSortedReports['vehicle_report'];
  // END DERIVED_DATA_AND_UTILS

  // START RENDER
  return (
    <Box sx={{ backgroundColor: theme.palette.background.paper }} padding={2.5}>
      <Stack direction="column" mb={2.5}>
        <Stack direction="row">
          <CustomIcons.IdMonitorIcon color="primary" />
          <Text variant="h3"> Personal Report Monitoring</Text>
        </Stack>

        <Text variant="body1">
          Monitor your reports for changes in your public records related to
          your name, properties, registered vehicles, phone numbers, email
          addresses, or social media accounts
        </Text>
      </Stack>

      <Stack direction={['column', 'row']} gap={2.5} flexWrap={'wrap'}>
        {!isHidden('person') && (
          <ClaimedReportMonitorsContainer
            reportMonitors={claimedPersonReports}
            rawReportType={'detailed_person_report'}
            reportType={'person'}
          />
        )}
        {!isHidden('property') && (
          <ClaimedReportMonitorsContainer
            reportMonitors={claimedPropertyReports}
            rawReportType={'property_report'}
            reportType={'property'}
          />
        )}
        {!isHidden('phone') && (
          <ClaimedReportMonitorsContainer
            reportMonitors={claimedPhoneReports}
            rawReportType={'reverse_phone_report'}
            reportType={'phone'}
          />
        )}
        {!isHidden('vehicle') && (
          <ClaimedReportMonitorsContainer
            reportMonitors={claimedVehicleReports}
            rawReportType={'vehicle_report'}
            reportType={'vehicle'}
          />
        )}
        {!isHidden('email') && (
          <ClaimedReportMonitorsContainer
            reportMonitors={claimedEmailReports}
            rawReportType={'social_network_report'}
            reportType={'email'}
          />
        )}
        {!isHidden('username') && (
          <ClaimedReportMonitorsContainer
            reportMonitors={claimedSocialMediaReports}
            rawReportType={'username_report'}
            reportType={'username'}
          />
        )}
      </Stack>
    </Box>
  );
  // END RENDER
};
